import React from 'react';

function Team() {

  // Javascript for fade-out when no longer hovering image
  document.addEventListener('animationstart', function (e) {
    if (e.animationName === 'fade-in') {
        e.target.classList.add('did-fade-in');
    }
  });
  
  document.addEventListener('animationend', function (e) {
    if (e.animationName === 'fade-out') {
        e.target.classList.remove('did-fade-in');
     }
  });

  return (
    <section className="relative">
      <div className="max-w-6xl mx-auto bg-blue-300 bg-opacity-40 mb-20 rounded-2xl" 
      data-aos="zoom-y-out" data-aos-offset="200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="py-12">

            {/* Section header */}
            <div className="max-w-3xl mx-auto text-center pb-12 md:pb-20">
              <h2 className="h2 text-blue-200">Meie innovaatiline meeskond</h2>
            </div>

            {/* Team members */}
            <div className="max-w-sm sm:max-w-6xl mx-auto sm:flex sm:flex-wrap sm:justify-center -my-6 sm:-my-8 sm:-mx-3" 
            data-aos-id-team>

              {/* greta */}
              <div className="sm:w-1/2 md:w-1/3 py-6 sm:py-8 sm:px-3" 
              data-aos="zoom-y-out" data-aos-delay="0" data-aos-anchor="[data-aos-id-team]" data-aos-offset="250">
                <div className="flex flex-col items-center">
                  <img className="rounded-full mb-4" src={require('../images/team/team_placeholder.png').default} width="120" height="120" alt="Team member 01" />
                  <h4 className="text-xl font-extrabold mb-1 text-gray-900">Greta Vaus</h4>
                  <div className="text-gray-200 opacity-90 font-medium mb-2">Tootmine & Logistika</div>
                </div>
              </div>

              {/* siim */}
              <div className="sm:w-1/2 md:w-1/3 py-6 sm:py-8 sm:px-3"
              data-aos="zoom-y-out" data-aos-delay="200" data-aos-anchor="[data-aos-id-team]" data-aos-offset="250">
                <div className="flex flex-col items-center">
                  <img className="rounded-full mb-4" src={require('../images/team/team_placeholder.png').default} width="120" height="120" alt="Team member 02" />
                  <h4 className="text-xl font-extrabold mb-1 text-gray-900">Siim Vaus</h4>
                  <div className="text-gray-200 opacity-90 font-medium mb-2">IT tugiteenused</div>
                  <div className="text-sm text-gray-300 opacity-80 font-medium">
                    <a className="hover:underline" href="https://github.com/Wauchy" target="_blank" rel="noopener noreferrer">
                      GitHub
                    </a> 
                    {" "}·{" "}
                    <a className="hover:underline" href="https://www.linkedin.com/in/siimvaus/" target="_blank" rel="noopener noreferrer">
                      LinkedIn
                    </a>
                  </div>
                </div>
              </div>

              {/* kasper */}
              <div className="sm:w-1/2 md:w-1/3 py-6 sm:py-8 sm:px-3"
              data-aos="zoom-y-out" data-aos-delay="400" data-aos-anchor="[data-aos-id-team]" data-aos-offset="250">
                <div className="flex flex-col items-center">
                  <div className="hover-trigger">
                    <img className="rounded-full mb-4" src={require('../images/team/kasper.jpeg').default} width="120" height="120" alt="Team member 03"/>
                    <div class="absolute bg-blue-200 p-1 w-auto left-0 mb-32 bottom-0 hover-target">
                      <img className="relative z-10" src={require('../images/team/kasper_full.jpeg').default} width="auto" alt="Team member 03"/>
                    </div>
                  </div>
                  <h4 className="text-xl font-extrabold mb-1 text-gray-900">Kasper Vaus</h4>
                  <div className="text-gray-200 opacity-90 font-medium mb-2">Graafika & Disain</div>
                  <div className="text-sm text-gray-300 opacity-80 font-medium">
                    <a className="hover:underline" href="https://github.com/adaresa" target="_blank" rel="noopener noreferrer"
                      >GitHub
                    </a> 
                    {" "}·{" "}
                    <a className="hover:underline" href="https://www.linkedin.com/in/kasper-vaus/" target="_blank" rel="noopener noreferrer">
                      LinkedIn
                    </a>
                  </div>
                </div>
              </div>

              {/* aivar */}
              <div className="sm:w-1/2 md:w-1/3 py-6 sm:py-8 sm:px-3"
              data-aos="zoom-y-out" data-aos-delay="600" data-aos-anchor="[data-aos-id-team]" data-aos-offset="250">
                <div className="flex flex-col items-center">
                  <div className="hover-trigger">
                    <img className="rounded-full mb-4" src={require('../images/team/aivar.jpg').default} width="120" height="120" alt="Team member 04"/>
                    <div class="absolute bg-blue-200 p-1 w-auto left-0 mb-28 bottom-0 hover-target">
                      <img className="relative z-20" src={require('../images/team/aivar_full.jpg').default} width="auto" alt="Team member 04"/>
                    </div>
                  </div>

                  <h4 className="text-xl font-extrabold mb-1 text-gray-900">Aivar Vaus</h4>
                  <div className="text-gray-200 opacity-90 font-medium mb-2">Müük & Turundus</div>
                </div>
              </div>

              {/* diego */}
              <div className="sm:w-1/2 md:w-1/3 py-6 sm:py-8 sm:px-3"
              data-aos="zoom-y-out" data-aos-delay="800" data-aos-anchor="[data-aos-id-team]" data-aos-offset="250">
                <div className="flex flex-col items-center">
                  <div className="hover-trigger">
                    <img className="rounded-full mb-4" src={require('../images/team/diego.png').default} width="120" height="120" alt="Team member 04"/>
                    <div class="absolute bg-blue-200 p-1 w-auto left-0 mb-28 bottom-0 hover-target">
                      <img className="relative z-20" src={require('../images/team/diego.png').default} width="auto" alt="Team member 04"/>
                    </div>
                  </div>
                  <h4 className="text-xl font-extrabold mb-1 text-gray-900">Don Diego</h4>
                  <div className="text-gray-200 opacity-90 font-medium mb-2">Teraapia</div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Team;